import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'
import { TranslatedTextType } from '../../hooks/shared'
import { ThemeBrandColorsType } from 'BrandTheme/types'

type BrandColorType = keyof ThemeBrandColorsType
interface ButtonNext {
  buttonText: TranslatedTextType
  customClassName?: string
  disabled?: boolean
  outlined?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  handleClick?(values?: unknown): void
  testId?: string
  color?: BrandColorType
  style?: React.CSSProperties
}

interface ButtonNextStyles {
  outlined: boolean
  color?: BrandColorType
}

const useStyles = makeStyles<ButtonNextStyles>()((theme: Theme, props) => ({
  buttonNext: {
    fontSize: '1rem',
    border: props.outlined ? `1px solid ${theme.palette.primary.main}` : 'none',
    boxShadow: props.outlined && 'none',
    [theme.breakpoints.up('md')]: {
      maxWidth: '345px',
    },
    textTransform: 'none',
  },

  button: {
    justifyContent: 'left',
    margin: theme.spacing(2, 0, 2, 0),
    padding: theme.spacing(2),
    color: theme.brand.colors.textMain,
    backgroundColor: theme.palette.background.paper,
    ...theme.brand.assets.layout?.customFnolButtonStyle,
    '&:hover': {
      color: theme.brand.colors.clean,
      backgroundColor: theme.brand.colors.main,
      opacity: 1,
      ...theme.brand.assets.layout?.customFnolButtonStyle,
    },
  },

  buttonColor: {
    color: theme.brand.colors[props.color],
  },
}))

const FNOLButton: FC<ButtonNext> = ({
  buttonText,
  customClassName,
  disabled = false,
  outlined = false,
  startIcon,
  endIcon,
  handleClick,
  testId = 'FNOLButton',
  color,
  style,
}) => {
  const { classes, cx } = useStyles({ outlined, color })

  return (
    <Button
      data-testid={testId}
      disabled={disabled}
      onClick={handleClick}
      variant='contained'
      size='medium'
      className={cx(
        classes.buttonNext,
        classes.button,
        color && classes.buttonColor,
        customClassName
      )}
      fullWidth
      startIcon={startIcon}
      endIcon={endIcon}
      style={{ textAlign: 'left', ...style }}
    >
      {buttonText}
    </Button>
  )
}

export default FNOLButton
